<template>
  <div class="completion__container animated fadeIn">
    <b-row class="m-xl-2">
      <b-col md="4">
        <div class="flex-inline-form-md">
          <h4>
            Shipment Completion
            <span
              v-b-toggle.completion-setting
              title="Setup Completion"
              class="fa fa-cog completion completion-setting-icon">
            </span>
            <b-button
              @click="handleExportCompletion"
              v-if="loaded && !emptyData"
              title="Export Completion to Excel"
              variant="outline-primary"
              size="sm">{{ isBusyExport ? 'Exporting ...' : 'Export' }}
            </b-button>
          </h4>
          <b-collapse id="completion-setting">
            <b-card>
              <b-form>
                <label for="date-range">Date Range</label>
                <b-form-group>
                  <date-picker
                    :editable="false"
                    :clearable="false"
                    :shortcuts="dateRangeOptions"
                    id="date-range"
                    lang="en"
                    v-model="dateRange"
                    type="date"
                    range-separator="to"
                    format="YYYY-MM-DD" range>
                  </date-picker>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox
                    v-model="deliveryDateCheckbox"
                    name="delivery-date-check"
                    value="use-delivery-date"
                    unchecked-value="not-use-delivery-date"
                  > Filter by Delivery Date </b-form-checkbox>
                </b-form-group>
                <label for="sort-by">Sort By</label>
                <b-form-group>
                  <b-form-select id="sort-by" v-model="sortBy" :options="sortByOptions"></b-form-select>
                </b-form-group>
                <label for="sort-direction">Sort Direction</label>
                <b-form-group>
                  <b-form-select id="sort-direction" v-model="sortDirection" :options="sortDirectionOptions"></b-form-select>
                </b-form-group>
                <hr>
                <b-button
                  @click="applyCompletionSetup"
                  variant="primary">Apply</b-button>
                <b-button
                  v-b-toggle="'completion-setting'"
                  variant="outline-danger"
                  class="pull-right">Cancel</b-button>
              </b-form>
            </b-card>
          </b-collapse>
        </div>
      </b-col>
      <b-col
        md="8"
        class="p-xl-0"
        v-if="!(loaded && emptyData && !activeSearchMode)"
      >
        <b-input-group>
          <b-input-group-text
            slot="append"
          >
            <i class="fa fa-search"></i>
          </b-input-group-text>
          <b-form-input
            type="text"
            placeholder="Search Data by shipment number, order number, customer or driver"
            @focus="activeSearchMode = true"
            @blur="activeSearchMode = false"
            debounce="500"
            v-model="searchQuery">
          </b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <p v-show="!loaded" class="no__data loading text-center">Loading...</p>
    <p v-if="loaded && emptyData" class="no__data text-center">No Data Available</p>
    <b-row v-if="modeColumn === 1">
      <b-col class="single_container">
        <div v-click-outside="hidePopover" class="completion__list row m-0">
          <div v-for="item in filteredSummaries"
            :ref="'shipment__' + item.id"
            :class="'shipment__item shipment__' + item.id"
            :key="item.id"></div>
        </div>
      </b-col>
    </b-row>
    <b-row v-click-outside="hidePopover" v-if="modeColumn === 2">
      <b-col class="first_column">
        <div class="completion__list row m-0">
          <div style="width: 100%" v-for="firstItem in firstColumnShipment"
            :ref="'shipment__' + firstItem.id"
            :class="'shipment__item shipment__' + firstItem.id"
            :key="firstItem.id">
          </div>
        </div>
      </b-col>
      <b-col class="second_column">
        <div class="completion__list row m-0">
          <div style="width: 100%" v-for="secondItem in secondColumnShipment"
            :ref="'shipment__' + secondItem.id"
            :class="'shipment__item shipment__' + secondItem.id"
            :key="secondItem.id"></div>
        </div>
      </b-col>
    </b-row>
    <b-modal content-class="content-fullscreen" dialog-class="modal-fullscreen" hide-backdrop hide-footer size="xl" ref="modal" :title="clickedVehicle">
      <div v-if="mapState === 'loading'">
        <p style="margin-bottom: 0px;">Loading data...</p>
      </div>
      <div v-if="mapState === 'failed'">
        <p style="margin-bottom: 0px;">Failed fetch data :(</p>
      </div>
      <div v-if="mapState === 'ready'">
        <div class="legend-container">
            <b-form-checkbox
              v-model="tooltipCheckbox"
              name="tooltip-check"
              value="show-tooltip"
              unchecked-value="hide-tooltip"
              inline
            > Show Tooltip </b-form-checkbox>
            <b-form-checkbox
              v-model="planRouteCheckbox"
              name="plan-route"
              value="show-plan-route"
              unchecked-value="hide-plan-route"
              inline
            > Plan Route (<span class="plan-route line-mark"></span>) </b-form-checkbox>
            <b-form-checkbox
              v-model="realRouteCheckbox"
              name="real-route"
              value="show-real-route"
              unchecked-value="hide-real-route"
              inline
            > Real Route (<span class="real-route line-mark"></span>) </b-form-checkbox>
            <b-form-checkbox
              v-model="waitingDestCheckbox"
              name="waiting-destination"
              value="show-waiting-destination"
              unchecked-value="hide-waiting-destination"
              inline
            > Waiting Destination (<img src="https://secure-gps.street-directory.com.au/assets/img/tms/destination-waiting.png" class="waiting-destination">) </b-form-checkbox>
            <b-form-checkbox
              v-model="finishDestCheckbox"
              name="finish-destination"
              value="show-finish-destination"
              unchecked-value="hide-finish-destination"
              inline
            > Finish Destination (<img src="https://secure-gps.street-directory.com.au/assets/img/tms/destination-finish.png" class="finish-destination">) </b-form-checkbox>
            <div class="legend-item">
              Origin Area (<img src="https://secure-gps.street-directory.com.au/assets/img/tms/origin-area.png" class="origin-area" alt="Origin Area">)
            </div>
            <div class="legend-item">
              Current Vehicle Location (<img src="https://secure-gps.street-directory.com.au/assets/img/bookmark/truck_in_movement.png" class="current-vehicle-location" alt="Current Vehicle Location">)
            </div>
        </div>
        <br>
        <l-map
          ref="map"
          @ready="onMapReady"
          :style="getMapStyles()"
          :min-zoom="1"
          :max-zoom="20"
          :bounds="bounds"
          :zoom.sync="zoom"
          :center="center">
          <l-tile-layer :url="url"></l-tile-layer>
          <l-marker v-for="(marker, indexMarker) in markerPoints"
            :attribution="getMarkerAttribution(marker)"
            :key="`marker-${indexMarker}`"
            :lat-lng="getMarkerPoint(marker)"
            :icon="getMarkerIcon(marker)">
            <l-tooltip :options="tooltipOptions">
              <p style="margin-bottom: 0px;">
                <span v-if="marker.type === 'destination'">
                  <b>{{ marker.customer.name }}</b>
                </span>
                <span v-if="marker.type === 'origin'">
                  <b>Origin Area</b>
                </span>
                <span v-if="marker.type === 'vehicle'">
                  <b>Current Location</b>
                </span>
              </p>
              <p style="margin-bottom: 0px;">{{ marker.name }}</p>
              <p v-if="marker.type === 'destination'" style="margin-bottom: 0px;"><b>{{ marker.sequence === null ? 1 : marker.sequence + 1 }}</b></p>
            </l-tooltip>
          </l-marker>
          <l-polygon v-for="(poly, indexPoly) in polyCollections"
            :latLngs="get(poly, 'geometry.coordinates')"
            :key="`poly-${indexPoly}`"></l-polygon>
          <l-circle v-for="(circle, indexCircle) in circleCollections"
            :lat-lng="getCircleCoordinates(circle)"
            :radius="getCircleRadius(circle)"
            :key="`circle-${indexCircle}`"></l-circle>
          <l-polyline
            v-for="(line, indexLine) in lineCollections"
            :color="line.color ? line.color : 'red'"
            :key="`line-${indexLine}`"
            :attribution="line.typeRoute"
            :lat-lngs="get(line, 'coordinates')"></l-polyline>
        </l-map>
      </div>
    </b-modal>
  </div>
</template>
<script>
import userMixin from '@/mixins/user';
import L from 'leaflet';
import { select, event } from 'd3';
import { isEmpty, first, get, cloneDeep, orderBy, isNull } from 'lodash';
import moment from 'moment';
import { format, subDays, differenceInMinutes } from 'date-fns';
import ClickOutside from 'vue-click-outside';
import DatePicker from 'vue2-datepicker';
import localforage from 'localforage';
import { LMap, LTileLayer, LMarker, LTooltip, LIcon, LPolygon, LCircle, LPolyline } from 'vue2-leaflet';
import chart from './index';

export default {
  name: 'completion',
  mixins: [userMixin],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LIcon,
    LPolygon,
    LCircle,
    LPolyline,
    DatePicker,
  },
  data() {
    return {
      activeSearchMode: false,
      deliveryDateCheckbox: 'use-delivery-date',
      tooltipObjects: [],
      dateRange: [new Date(), new Date()],
      sortBy: 'delivery-date',
      sortDirection: 'desc',
      selectedDateRange: [],
      selectedSortBy: null,
      selectedSortDirection: null,
      keySetting: 'completion-setting',
      sortByOptions: [
        { value: 'shipment-number', text: 'Shipment Number' },
        { value: 'vehicle-reg-no', text: 'Vehicle Reg No' },
        { value: 'driver-name', text: 'Driver Name' },
        { value: 'delivery-date', text: 'Delivery Date' },
      ],
      sortDirectionOptions: [
        { value: 'asc', text: 'Ascending' },
        { value: 'desc', text: 'Descending' },
      ],
      dateRangeOptions: [
        {
          text: 'Today',
          onClick: () => {
            const today = [new Date(), new Date()];
            this.dateRange = today;
            return today;
          },
        },
        {
          text: 'Yesterday until now',
          onClick: () => {
            const yesterday = [subDays(new Date(), 1), new Date()];
            this.dateRange = yesterday;
            return yesterday;
          },
        },
        {
          text: 'Two days ago until now',
          onClick: () => {
            const twoDaysAgo = [subDays(new Date(), 2), new Date()];
            this.dateRange = twoDaysAgo;
            return twoDaysAgo;
          },
        },
      ],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      center: [-6.17543846855061, 106.86290799928327],
      coordinates: [0, 0],
      zoom: 13,
      tooltipOptions: {
        permanent: true,
        direction: 'top',
        offset: L.point(0, -30),
      },
      defaultCircleRadius: 75,
      markerPoints: [],
      polyCollections: [],
      circleCollections: [],
      lineCollections: [],
      circleColor: 'red',
      clickedVehicle: '',
      mapState: 'loading',
      summaries: [],
      filteredSummaries: [],
      firstColumnShipment: [],
      secondColumnShipment: [],
      loaded: false,
      popover: null,
      tooltip: null,
      timeout: null,
      filterState: ['ON_PROCESS', 'CREATED', 'FINISH', 'FINISH_LOADING', 'READY_TO_LOAD'],
      historyProgress: {},
      useTestFakeProgress: false,
      reloadDelayTime: 15e3,
      icons: {
        iconRetinaUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-icon-2x.png',
        iconUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-icon.png',
        shadowUrl: 'https://unpkg.com/leaflet@1.2.0/dist/images/marker-shadow.png',
      },
      bounds: L.latLngBounds(
        { lat: 51.476483373501964, lng: -0.14668464136775586 },
        { lat: 51.52948330894063, lng: -0.019140238291583955 },
      ),
      tooltipCheckbox: 'show-tooltip',
      planRouteCheckbox: 'show-plan-route',
      realRouteCheckbox: 'show-real-route',
      waitingDestCheckbox: 'show-waiting-destination',
      finishDestCheckbox: 'show-finish-destination',
      mapFeatureObjects: {},
      isBusyExport: false,
      searchQuery: '',
      searchListData: [],
    };
  },
  created() {
    this.prepareLeafletIcon();
    this.getSetting().then(() => {
      this.loadData().then(() => {
        this.setupHeight();
        this.onResizeWindow();
        this.loaded = true;
      });
    });
  },
  mounted() {
    this.toggleSideBar(true);
  },
  computed: {
    listShipmentFiltered() {
      const filter = new RegExp(this.searchQuery, 'i');
      let filteredShipment = [];
      const isMatchOrderNumber = [];
      const isMatchCustomerName = [];
      const filteredDataNumberAndDriver = this.filteredSummaries.filter((shipment) => {
        const isMatchShipmentNumber = shipment.number.match(filter);
        const isMatchDriver = get(shipment, 'vehicle.driver.name', '-').match(filter);
        shipment.destinations.forEach((a) => {
          a.orders.forEach((s) => {
            if (s.number.match(filter)) {
              isMatchOrderNumber.push(shipment);
            } else if (s.customer.name.match(filter)) {
              isMatchCustomerName.push(shipment);
            }
          });
        });
        return isMatchShipmentNumber || isMatchDriver;
      });
      if (!isEmpty(filteredDataNumberAndDriver)) {
        filteredShipment = filteredDataNumberAndDriver;
      } else if (!isEmpty(isMatchOrderNumber)) {
        // const getColor = document.querySelector('.drops');
        // const dataPoint = getColor.getElementsByTagName('circle');
        //  test ganti warna titik
        // dataPoint[1].setAttribute('fill', '#22ee5b');
        // dataPoint[1].setAttribute('r', '8');
        filteredShipment = isMatchOrderNumber;
      } else if (!isEmpty(isMatchCustomerName)) {
        filteredShipment = isMatchCustomerName;
      }
      return filteredShipment;
    },
    shipments() {
      return this.$store.getters['shipment_md/shipments/shipments'];
    },
    emptyData() {
      const empty = this.modeColumn === 1 ?
        isEmpty(this.filteredSummaries) :
        (isEmpty(this.firstColumnShipment) && isEmpty(this.secondColumnShipment));
      return empty;
    },
    minimizeSidebar() {
      return this.$store.getters.minimizeSidebar;
    },
    modeColumn() {
      return this.$store.getters['shipment_md/shipments/completion_column'];
    },
    showPlanRoute() {
      return this.planRouteCheckbox === 'show-plan-route';
    },
    showRealRoute() {
      return this.realRouteCheckbox === 'show-real-route';
    },
    showWaitingDestination() {
      return this.waitingDestCheckbox === 'show-waiting-destination';
    },
    showFinishDestination() {
      return this.finishDestCheckbox === 'show-finish-destination';
    },
    showTooltip() {
      return this.tooltipCheckbox === 'show-tooltip';
    },
    isFilterByDeliveryDate() {
      return this.deliveryDateCheckbox === 'use-delivery-date';
    },
    isAUWebsite() {
      return window.location.origin.indexOf('com.au') >= 0;
    },
  },
  beforeDestroy() {
    this.toggleSideBar(false);
    clearTimeout(this.timeout);
    select('.popover__completion').remove();
  },
  methods: {
    getMapStyles() {
      const height = window.innerHeight - 125;
      const styles = `height: ${height}px; width: 100%;`;
      return styles;
    },
    loadData() {
      const { start_date, end_date } = this.prepareRangeDate();
      const process = (shipments) => {
        if (!isEmpty(shipments)) {
          this.summaries = shipments;

          this.filterSummary(shipments);
          this.setupSortShipment();
          if (this.modeColumn === 2) {
            this.firstColumnShipment = [];
            this.secondColumnShipment = [];
            const lenData = this.filteredSummaries.length;
            const limitSeparate = Math.round(lenData / 2);

            this.filteredSummaries.forEach((shipment, idx) => {
              if (idx < limitSeparate) {
                this.firstColumnShipment.push(shipment);
              } else {
                this.secondColumnShipment.push(shipment);
              }
            });
          }
          setTimeout(() => {
            this.drawChart();
            this.reloadData();
          }, 1e3);
        } else {
          const todayDate = format(new Date(), 'YYYY-MM-DD');
          const yerterday = subDays(new Date(), 1);
          const isToday = start_date === todayDate && end_date === todayDate;
          const yerterdayUntilNow = [yerterday, todayDate];

          if (isToday) {
            this.dateRange = yerterdayUntilNow;
            this.selectedDateRange = yerterdayUntilNow;
            this.loaded = false;
            return this.loadData().then(() => { this.loaded = true; });
          }
        }
        return Promise.resolve();
      };

      const { filterState, isFilterByDeliveryDate } = this;
      const payloads = {
        start_date,
        end_date,
        sort_by: 'CREATED_AT',
        sort_direction: 'ASC',
        state_filter_or: filterState,
        filter_by_delivery_date: isFilterByDeliveryDate,
      };
      const fireApi = this.$store.dispatch('shipment_md/shipments/LOAD_SHIPMENTS_SUMMARY_BY_RANGE_DATE', payloads);

      return fireApi
        .then(process)
        .catch(() => {
          setTimeout(() => {
            this.loadData();
          }, 1e3);
        });
    },
    reloadData() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.loadData();
      }, this.reloadDelayTime);
    },
    filterSummary(shipments) {
      const filteredData = [];
      shipments.forEach((shipment) => {
        const isHasDestination = shipment.destinations.length > 0;
        if (isHasDestination) {
          if (this.useTestFakeProgress) {
            const reformatDistance = this.setupZeroDistance(shipment);
            const updatedProgress = this.updateFakeProgress(reformatDistance);
            filteredData.push(updatedProgress);
          } else {
            const reformatDistance = this.setupZeroDistance(shipment);
            this.setupShipmentDelivery(reformatDistance);
            filteredData.push(reformatDistance);
          }
        }
      });

      this.filteredSummaries = filteredData;

      if (!isEmpty(this.searchQuery)) {
        this.findShipmentByValue();
      }

      return filteredData;
    },
    findShipmentByValue() {
      const regExp = new RegExp(this.searchQuery, 'i');
      const checkKeys = [
        {
          name: 'driver_name',
          key: 'driver.name',
        },
        {
          name: 'shipment_number',
          key: 'number',
        },
        {
          name: 'customer_name',
          key: 'destinations',
          functionCheck: (data) => {
            const destinationMatches = [];
            data.forEach((dt) => {
              const orders = get(dt, 'orders', []);
              const value = get(dt, 'name', '');
              let isMatch = value.match(regExp);
              if (isMatch) { destinationMatches.push(dt); }

              // check order number also
              orders.forEach((od) => {
                const orderNumber = get(od, 'number', '');
                const matchOrder = orderNumber.match(regExp);
                if (matchOrder) {
                  destinationMatches.push(dt);
                  isMatch = true;
                  return true;
                }
                const soNumber = get(od, 'metadata.order_number', '');
                const matchSO = soNumber.match(regExp);
                if (matchSO) {
                  destinationMatches.push(dt);
                  isMatch = true;
                  return true;
                }
                return false;
              });

              dt.highlight = isMatch ? 1 : 0;
            });
            return destinationMatches.length > 0;
          },
        },
      ];

      const filtered = this.filteredSummaries.filter((shipment) => {
        const matches = [];

        checkKeys.forEach(({ name, key: keyCheck, functionCheck }) => {
          const valueDt = get(shipment, keyCheck, '');
          const isMatch = !functionCheck ? valueDt.match(regExp) : functionCheck(valueDt);
          if (isMatch) { matches.push(name); }
        });

        return matches.length > 0;
      });

      this.filteredSummaries = filtered;
      return filtered;
    },
    setupZeroDistance(shipment) {
      const { destinations } = shipment;
      const newDestinations = destinations.map((destination) => {
        const { direction = null } = destination;
        const defaultDistance = 1e2;
        if (isEmpty(direction)) {
          destination.direction = {
            distance: defaultDistance,
          };
        } else {
          const lessThan100Meter = Number(destination.direction.distance) < defaultDistance;
          const currentDistance = destination.direction.distance;
          destination.direction.distance = lessThan100Meter
            ? defaultDistance
            : currentDistance;
        }
        destination.highlight = 0;
        return destination;
      });

      shipment.destinations = newDestinations;
      return shipment;
    },
    setupShipmentDelivery(shipment) {
      const shipmentDateMeta = get(shipment, 'metadata.shipment_date_string') || null;
      const shipmentCreateDate = get(shipment, 'created_at') || null;
      const formatedDate = shipmentDateMeta !== null
        ? shipmentDateMeta
        : shipmentCreateDate;

      shipment.delivery_date_unix = moment(formatedDate).unix();
      return shipment;
    },
    prepareRangeDate() {
      let start_date = new Date();
      let end_date = new Date();
      const { selectedDateRange = [] } = this;

      if (!isEmpty(selectedDateRange)) {
        ([start_date, end_date] = selectedDateRange);
      }

      return {
        start_date: format(start_date, 'YYYY-MM-DD'),
        end_date: format(end_date, 'YYYY-MM-DD'),
      };
    },
    setupSortShipment() {
      let sortedData = [];
      let field = 'delivery_date_unix';
      const { selectedSortBy, selectedSortDirection } = this;

      switch (selectedSortBy) {
        case 'shipment-number':
          field = 'number';
          break;
        case 'vehicle-reg-no':
          field = 'vehicle.reg_no';
          break;
        case 'driver-name':
          field = 'driver.name';
          break;
        default:
          field = 'delivery_date_unix';
          break;
      }

      sortedData = orderBy(this.filteredSummaries, field, selectedSortDirection);
      this.filteredSummaries = sortedData;
      return sortedData;
    },
    applyCompletionSetup() {
      const { dateRange, sortBy, sortDirection } = this;
      const settings = {
        sortBy,
        sortDirection,
      };
      this.selectedDateRange = dateRange;
      this.saveSetting(settings).then(() => {
        clearTimeout(this.timeout);
        this.loaded = false;
        this.filteredSummaries = [];
        this.loadData().then(() => { this.loaded = true; });
      });
    },
    saveSetting(value = {}) {
      return localforage.setItem(this.keySetting, value).then(() => {
        this.selectedSortBy = value.sortBy;
        this.selectedSortDirection = value.sortDirection;
      });
    },
    getSetting() {
      return localforage.getItem(this.keySetting).then((data) => {
        if (!isEmpty(data)) {
          this.sortBy = data.sortBy;
          this.sortDirection = data.sortDirection;
        }
        this.selectedSortBy = this.sortBy;
        this.selectedSortDirection = this.sortDirection;
      });
    },
    get(object, key) {
      return get(object, key) || '';
    },
    createPopup(popupType, dt) {
      let popup = null;
      if (popupType === 'popover') {
        select('.popover__completion').remove();

        const popover = select('body').selectAll('.popover__completion').data([dt]);
        popup = popover
          .enter()
          .append('div')
          .classed('popover__completion', true)
          .style('opacity', 0)
          .style('background-color', '#fff')
          .style('border', '1px solid #0000001a')
          .style('border-radius', '5px')
          .style('padding', '15px')
          .style('width', '300px')
          .style('z-index', 9999)
          .style('position', 'absolute')
          .style('pointer-events', 'none');
      }

      if (popupType === 'tooltip') {
        select('.tooltip__completion').remove();

        const tooltip = select('body').selectAll('.tooltip__completion').data([dt]);
        popup = tooltip
          .enter()
          .append('div')
          .classed('tooltip__completion', true)
          .style('padding', '5px')
          .style('background-color', '#fff')
          .style('border', '1px solid #0000001a')
          .style('border-radius', '5px')
          .style('opacity', 0)
          .style('z-index', 9999)
          .style('position', 'absolute')
          .style('pointer-events', 'none');
      }

      return popup;
    },
    drawChart() {
      let i = 0;
      const { filteredSummaries: shipments } = this;
      const mouseEvents = {
        onDropClick: this.onDropClick,
        onDropMouseover: this.onDropMouseover,
        onDropMouseout: this.onDropMouseout,
        onLinkClick: this.onLinkClick,
        hidePopover: this.hidePopover,
        onIconCarClick: this.onIconCarClick,
      };
      const isSingle = this.modeColumn === 1;
      const topContainer = isSingle ?
        document.querySelector('.container') || document.querySelector('.container-fluid') :
        document.querySelector('.first_column');
      const wgDimension = { width: topContainer.clientWidth };

      const draw = () => {
        const shipment = shipments[i];
        if (shipment) {
          const shipmentId = `shipment__${shipment.id}`;
          const shipmentDiv = this.$refs[shipmentId];
          const isLastShipment = i === shipments.length - 1;

          select(first(shipmentDiv))
            .data([shipment])
            .call(chart(
              mouseEvents,
              wgDimension,
              isLastShipment,
              isSingle,
              this.isPrambananConfig,
            ));

          i += 1;
          draw();
        }
      };
      draw();
    },
    onDropClick(dropType) {
      return (dt) => {
        const { orders, name } = dt;
        let content = '';

        this.onDropMouseout(2e2)();
        this.popover = this.createPopup('popover', dt);
        this.popover
          .transition()
          .duration(2e2)
          .style('opacity', 1)
          .style('pointer-events', 'auto');

        const setElem = (returnType) => {
          let tabs = '<ul class="nav nav-tabs" role="tablist">';
          let tabContents = '<div class="tab-content" style="margin-top: 10px; max-height: 300px; overflow-y: auto;">';
          const hrStyles = 'margin-top: 5px; margin-bottom: 5px;';
          const ulStyles = `
            margin-bottom: 0px;
            list-style-type: none;
            padding-left: 5px;
            padding-right: 5px;
          `;
          const liStyles = `
            margin-bottom: 4px;
            border-bottom: 1px solid #0000001a;
          `;

          orders.forEach((order, i) => {
            const {
              id, units, number, status, metadata,
            } = order;
            const isActive = i === 0;
            const classActive = isActive ? 'active' : '';
            const classShow = isActive ? 'show' : '';
            const numb = i + 1;

            const isRejected = status === 'REJECTED';
            const isCancelled = status === 'CANCELLED';
            const isConfirmed = status === 'CONFIRMED';
            const statusClass = isCancelled || isRejected ? 'text-danger' : '';

            if (returnType === 'tab') {
              tabs += `
                <li class="nav-item">
                  <a" class="nav-link ${classActive} ${statusClass}" id="${id}-tab" data-toggle="tab" href="#${id}" role="tab" aria-controls="${id}" aria-selected="${isActive}">${numb}</a>
                </li>`;
            } else {
              let orderContent = '';
              const canceledLabel = isCancelled ? 'Cancelled By' : 'Rejected By';

              orderContent += `<p style="margin-bottom: 0px;">Order Number : <strong>${number}</strong></p><hr style="${hrStyles}">`;

              if (this.isPrambananConfig) {
                const salesOrder = get(metadata, 'order_number', '-');
                orderContent += `
                  <p style="margin-bottom: 0px;">
                    Sales Order : <strong>${salesOrder}</strong>
                  </p>
                  <hr style="${hrStyles}">
                `;

                if (isConfirmed || isCancelled || isRejected) {
                  const timeInApp = get(metadata, 'time_in_app', '-');
                  const timeOutApp = get(metadata, 'time_out_app', '-');

                  let timeIn = get(metadata, 'time_in', timeInApp);
                  let timeOut = get(metadata, 'time_out', timeOutApp);
                  const timeDiff = differenceInMinutes(timeOut, timeIn);

                  timeIn = format(timeIn, 'DD MMM YYYY HH:mm');
                  timeOut = format(timeOut, 'DD MMM YYYY HH:mm');

                  orderContent += `
                    <p style="margin-bottom: 0px;">
                      Time In : <strong>${timeIn}</strong>
                    </p>
                    <hr style="${hrStyles}">
                    <p style="margin-bottom: 0px;">
                      Time Out : <strong>${timeOut}</strong>
                    </p>
                    <hr style="${hrStyles}">
                    <p style="margin-bottom: 0px;">
                      Total Time : <strong>${timeDiff} Minutes</strong>
                    </p>
                    <hr style="${hrStyles}">
                  `;
                }
              }

              orderContent += `<p style="margin-bottom: 0px;">Status : <strong class="${statusClass}">${status}</strong></p><hr style="${hrStyles}">`;

              if (isCancelled || isRejected) {
                let reason = '-';
                let cancelledBy = '-';

                if (metadata.abort) {
                  reason = get(metadata, 'abort.reason');
                  cancelledBy = get(metadata, 'abort.name');
                } else if (metadata.rejected) {
                  reason = get(metadata, 'rejected.reason');
                  cancelledBy = get(metadata, 'rejected.name');
                }

                orderContent += `
                  <p style="margin-bottom: 0px;">
                    Reason : <strong class="${statusClass}">${reason}</strong>
                  </p>
                  <hr style="${hrStyles}">
                `;
                orderContent += `
                  <p style="margin-bottom: 0px;">
                    ${canceledLabel} : <strong class="${statusClass}">${cancelledBy}</strong>
                  </p>
                  <hr style="${hrStyles}">
                `;
              }

              let rejectedNumbers = [];
              if (isRejected) {
                if (metadata.rejected_units) {
                  rejectedNumbers = Object.values(metadata.rejected_units);
                }
              }

              if (units && units.length) {
                orderContent += `<p class="text-center" style="margin-bottom: 0px;"><strong>Units</strong></p><hr style="${hrStyles}">`;
                orderContent += `<ul style="${ulStyles}" class="unit-list">`;
                units.forEach((unit) => {
                  const { number: unitNumber, type } = unit;
                  const unitBadgeRejected = rejectedNumbers.includes(unitNumber) ? '<span class="text-danger">(Rejected)</span>' : '';
                  orderContent += `<li style="${liStyles}">${unitNumber} - ${type} ${unitBadgeRejected}</li>`;
                });
                orderContent += '</ul>';
              }

              tabContents += `<div class="order-detail tab-pane fade ${classShow} ${classActive}" id="tab-${id}" role="tabpanel" aria-labelledby="${id}-tab">${orderContent}</div>`;
            }
          });

          return returnType === 'tab' ? `${tabs} </ul>` : `${tabContents} </div>`;
        };
        const customerName = this.get(dt, 'orders.0.customer.name');

        if (dropType === 'destination') {
          content = `
            <p style="margin-bottom: 0px" class="text-center"><strong>${customerName}</strong></p>
            <p style="margin-bottom: 0px" class="text-center">${name}</p>
            <p style="margin-bottom: 0px" class="text-center">Sequence - ${this.get(orders, '0.sequence') + 1}</p>
            <hr style="margin-top: 5px;">
            ${setElem('tab')}
            ${setElem('tab-content')}
          `;
        }

        if (dropType === 'current') {
          content = `
            <div style="padding: 5px;" class="latest-position">
              <p style="margin-bottom: 0px">Truck Name : <strong>${this.get(dt, 'vehicle.reg_no')}</strong></p>
              <hr style="margin-top: 5px;">
              <p style="margin-bottom: 0px">Address : <strong>${this.get(dt, 'vehicle.gps_devices.0.gps_info.road_name')}</strong></p>
              <hr style="margin-top: 5px;">
              <p>Longitude : <strong>${this.get(dt, 'vehicle.gps_devices.0.gps_info.longitude')}</strong></p>
              <hr style="margin-top: 5px;">
              <p style="margin-bottom: 0px">Latitude : <strong>${this.get(dt, 'vehicle.gps_devices.0.gps_info.latitude')}</strong></p>
            </div>
          `;
        }

        const popverWidth = document.querySelector('.popover__completion').clientWidth;
        const containerWidth = document.querySelector('.app').clientWidth;
        const isOverPosition = (containerWidth - event.pageX) < popverWidth;
        const leftPosition = isOverPosition ? (event.pageX - popverWidth) : event.pageX;

        this.popover.html(content)
          .style('left', `${leftPosition - 10}px`)
          .style('top', `${event.pageY + 20}px`);

        const tabs = this.popover.node().getElementsByClassName('nav-link');
        const tabKeys = Object.keys(tabs);
        tabKeys.map((key) => {
          const tab = tabs[key];
          tab.addEventListener('click', this.selectTab);
          return true;
        });
      };
    },
    hidePopover(e) {
      if (!isEmpty(e)) {
        const { target } = e;
        if (target.closest('.popover__completion')) {
          return false;
        }
      }

      if (!isEmpty(this.popover)) {
        this.popover = null;
        select('.popover__completion').remove();
      }

      return true;
    },
    selectTab(e) {
      const { target } = e;
      const popover = this.popover.node();
      const selectedId = target.getAttribute('aria-controls');
      const tabActive = popover.querySelector('.nav-link.active');
      const contentActive = popover.querySelector('.tab-pane.active');
      const targetContent = popover.querySelector(`#tab-${selectedId}`);

      const contentActiveId = contentActive.getAttribute('id');

      if (selectedId !== contentActiveId.split('-')[1]) {
        target.setAttribute('aria-selected', true);
        target.classList.add('active');

        tabActive.setAttribute('aria-selected', false);
        tabActive.classList.remove('active');

        targetContent.classList.add('show');
        targetContent.classList.add('active');

        contentActive.classList.remove('show');
        contentActive.classList.remove('active');
      }
    },
    onDropMouseover(dropType) {
      return (dt) => {
        this.tooltip = this.createPopup('tooltip', dt);
        this.tooltip
          .transition()
          .duration(200)
          .style('opacity', 1)
          .style('pointer-events', 'auto');
        let text = 'Click to see detail';

        if (dropType === 'current') {
          text = 'Click to see truck detail';
        } else if (dropType === 'origin') {
          const { code, name, metadata } = dt;

          text = `
            <div style="padding: 5px;" class="origin-info">
              <p>Code : <strong>${code}</strong></p>
              <hr style="margin-top: 5px;">
              <p>Name : <strong>${name}</strong></p>
              <hr style="margin-top: 5px;">
              <p>Address : <strong>${this.get(metadata, 'info.address')}</strong></p>
            </div>
          `;
        }

        this.tooltip.html(text)
          .style('left', `${event.pageX - 30}px`)
          .style('top', `${event.pageY + 20}px`);
      };
    },
    onDropMouseout(dur) {
      return () => {
        const duration = dur || 5e2;
        this.tooltip
          .transition()
          .duration(duration)
          .style('opacity', 0)
          .style('pointer-events', 'none');

        setTimeout(() => {
          select('.tooltip__completion').remove();
        }, duration + 50);
      };
    },
    onLinkClick(linkType) {
      return (dt) => {
        const id = linkType === 'number' ? this.get(dt, 'id') : this.get(dt, 'driver.id');
        const pageTarget = linkType === 'number' ? `shipment_md/shipments/${id}` : `admin/employees/${id}`;
        const linkLocation = `${window.origin}/#/${pageTarget}`;
        window.open(linkLocation, '_blank');
      };
    },
    setupHeight() {
      const dimension = this.getContainerDimension();
      const completionContainer = document.querySelector('.completion__container');
      const containerHeight = dimension.height;
      completionContainer.style.height = `${containerHeight - 48}px`;
      completionContainer.style.maxHeight = `${containerHeight - 48}px`;
    },
    getContainerDimension() {
      const topContainer = document.querySelector('.container') || document.querySelector('.container-fluid');
      const dim = {
        height: topContainer.clientHeight - 10,
        width: topContainer.clientWidth,
      };

      return dim;
    },
    updateFakeProgress(shipment) {
      const histories = cloneDeep(this.historyProgress);
      const { destinations, number } = shipment;

      let prevHistory = null;
      let totalFinish = 0;
      const newDestinations = destinations.map((destination, i) => {
        if (isEmpty(histories[number])) {
          histories[number] = {
            key: i,
            val: 0,
          };
        }

        if ((!isEmpty(prevHistory) && prevHistory.val === 100) &&
        prevHistory.key !== destinations.length - 1) {
          histories[number] = {
            key: i,
            val: 0,
          };
        }

        const { val: lastDt, key } = histories[number];
        if (Number(key) === i && lastDt !== 100) {
          histories[number].val += 10;
          destination.percentage = histories[number].val;
        }

        if (i < Number(key) || (histories[number].val === 100 &&
          histories[number].key === destinations.length - 1)) {
          destination.percentage = 100;
          destination.finish = true;
          totalFinish += 1;
        }

        this.historyProgress = histories;
        prevHistory = histories[number];

        return destination;
      });

      shipment.destinations = newDestinations;
      if (destinations.length > 1) {
        shipment.total_percentage = prevHistory.key >= 1 && totalFinish !== 0 ?
          Math.round((totalFinish / destinations.length) * 100, 2) :
          Math.round((0.5 / destinations.length) * 100, 2);
      } else {
        shipment.total_percentage = prevHistory.val;
      }

      return shipment;
    },
    onResizeWindow() {
      window.removeEventListener('resize', this.drawChart, true);
      window.addEventListener('resize', this.drawChart, true);
    },
    toggleSideBar(show) {
      this.$store.commit('SHOW_HIDE_BREADCRUMB', !show);
      this.$store.commit('SHOW_HIDE_FOOTER', !show);
      if (show) {
        this.$store.commit('MINIMIZE_SIDEBAR');
        document.body.classList.add('sidebar-minimized');
      } else {
        this.$store.commit('RESTORE_SIDEBAR');
        document.body.classList.remove('sidebar-minimized');
      }
    },
    prepareRealLineCollections(positions) {
      if (positions) {
        const coordinates = positions.map((dt) => {
          const lat = parseFloat(dt.alat);
          const lon = parseFloat(dt.along);
          return [lat, lon];
        });
        this.lineCollections.push({
          typeRoute: 'real-route',
          color: 'green',
          type: 'LineString',
          coordinates,
        });
      }
    },
    onIconCarClick() {
      return (dt) => {
        const { shipmentData = {} } = dt;
        const {
          id: shipmentId,
          vehicle = {},
          created_at,
          delivery_date,
        } = shipmentData;
        console.log(shipmentData);
        const gpsInfo = this.get(vehicle, 'gps_devices.0.gps_info') || null;

        const promises = [
          this.$store.dispatch('shipment_md/shipments/LOAD_SHIPMENT_DESTINATIONS', {
            shipment_id: shipmentId,
          }),
        ];

        let startDate = moment(created_at)
          .add(1, 'd')
          .set({ hour: 0, minute: 0, second: 0 })
          .format('YYYY-MM-DD HH:mm:ss');
        let endDate = moment(created_at)
          .add(1, 'd')
          .set({ hour: 23, minute: 59, second: 59 })
          .format('YYYY-MM-DD HH:mm:ss');

        if (delivery_date) {
          startDate = moment(delivery_date)
            .set({ hour: 0, minute: 0, second: 0 })
            .format('YYYY-MM-DD HH:mm:ss');
          endDate = moment(delivery_date)
            .set({ hour: 23, minute: 59, second: 59 })
            .format('YYYY-MM-DD HH:mm:ss');
        }

        if (vehicle) {
          const gpsNumber = get(vehicle, 'gps_devices.0.number');
          const payloadsPositions = {
            deviceid: gpsNumber,
            start_date: startDate,
            end_date: endDate,
          };
          promises.push(this.$store.dispatch('gpsDevices/GET_GPS_POSITIONS_BY_DEVICEID', payloadsPositions));
        }

        this.$refs.modal.show();
        this.clickedVehicle = vehicle.reg_no || '-';
        this.mapState = 'loading';
        Promise.all(promises).then((responses) => {
          const [shipmentDestinations, gpsPositions] = responses;
          const { destinations, origin } = shipmentDestinations;
          const lines = [];

          destinations.forEach((destination) => {
            const order = first(destination.orders);
            const { direction } = order;
            if (direction) {
              lines.push(direction.geo_poly);
            }
          });
          this.lineCollections = lines.map((line) => {
            const { coordinates } = line;
            const switchedCoordinates = coordinates.map(coordinate => (
              [coordinate[1], coordinate[0]]
            ));
            line.coordinates = switchedCoordinates;
            line.typeRoute = 'plan-route';
            return line;
          });
          this.prepareRealLineCollections(gpsPositions);

          const points = destinations
            .filter((dest) => {
              const order = first(dest.orders);
              return !isEmpty(order.destination);
            })
            .map((dest) => {
              const order = first(dest.orders);
              const coordinates = get(order, 'destination.geometry.coordinates', []);

              const firstCoordinate = get(coordinates, '0.0') || [0, 0];
              const inValidCoordinates = firstCoordinate[0] > 0;

              if (inValidCoordinates && coordinates.length) {
                const switched = coordinates.map((dtCoordinates) => {
                  const switchedCoordinates = dtCoordinates.map(coordinate => (
                    [coordinate[1], coordinate[0]]
                  ));
                  return switchedCoordinates;
                });
                if (order.destination) {
                  order.destination.geometry.coordinates = switched;
                }
              }

              const newObj = {
                type: 'destination',
                sequence: order.sequence,
                customer: dest.customer,
                percentage: dest.percentage,
              };
              Object.assign(newObj, order.destination);
              return newObj;
            });

          if (origin) {
            origin.type = 'origin';
            points.push(origin);
          }

          if (gpsInfo) {
            points.push({
              type: 'vehicle',
              latitude: gpsInfo.latitude,
              longitude: gpsInfo.longitude,
              name: vehicle.reg_no,
            });
          }

          const bounds = L.latLngBounds(points.map(pt => (
            { lat: pt.latitude, lng: pt.longitude }
          )));

          this.bounds = bounds;
          this.markerPoints = points;
          setTimeout(() => {
            this.mapState = 'ready';
          }, 5e2);
        }).catch((error) => {
          console.error(error);
          this.mapState = 'failed';
        });
      };
    },
    onMapReady() {
      this.pullMapFeatureObject();
      Object.keys(this.mapFeatureObjects).forEach((key) => {
        this.updateStateFeatureVisibility(key);
      });

      setTimeout(() => {
        this.$refs.map.mapObject.invalidateSize();
      }, 1e2);
    },
    pullMapFeatureObject() {
      const { mapObject } = this.$refs.map;

      this.mapFeatureObjects['real-route'] = [];
      this.mapFeatureObjects['plan-route'] = [];
      this.mapFeatureObjects['waiting-destination'] = [];
      this.mapFeatureObjects['finish-destination'] = [];
      this.mapFeatureObjects.tooltip = [];

      mapObject.eachLayer((layer) => {
        const pane = get(layer, 'options.pane');
        const attribution = get(layer, 'options.attribution', '');
        if (pane === 'tooltipPane') {
          this.mapFeatureObjects.tooltip.push(layer);
        }
        if (pane === 'markerPane' && attribution === 'waiting-destination') {
          this.mapFeatureObjects['waiting-destination'].push(layer);
        }
        if (pane === 'markerPane' && attribution === 'finish-destination') {
          this.mapFeatureObjects['finish-destination'].push(layer);
        }
        if (pane === 'overlayPane' && attribution === 'plan-route') {
          this.mapFeatureObjects['plan-route'].push(layer);
        }
        if (pane === 'overlayPane' && attribution === 'real-route') {
          this.mapFeatureObjects['real-route'].push(layer);
        }
      });
    },
    updateStateFeatureVisibility(key) {
      const { mapObject } = this.$refs.map;
      let show = false;
      let features = [];
      let removeFeatureFunction = () => {};

      if (key === 'waiting-destination' || key === 'finish-destination') {
        show = key === 'waiting-destination' ? this.showWaitingDestination : this.showFinishDestination;
        features = this.mapFeatureObjects[key];
        removeFeatureFunction = (feature) => {
          const { pane, attribution } = feature.options;
          if (pane === 'markerPane' && attribution === key) {
            feature.removeFrom(mapObject);
          }
        };
      } else if (key === 'plan-route' || key === 'real-route') {
        show = key === 'plan-route' ? this.showPlanRoute : this.showRealRoute;
        features = this.mapFeatureObjects[key];
        removeFeatureFunction = (feature) => {
          const { pane, attribution } = feature.options;
          if (pane === 'overlayPane' && attribution === key) {
            feature.removeFrom(mapObject);
          }
        };
      } else if (key === 'tooltip') {
        show = this.showTooltip;
        features = this.mapFeatureObjects[key];
        removeFeatureFunction = (feature) => {
          const { pane } = feature.options;
          if (pane === 'tooltipPane') {
            feature.removeFrom(mapObject);
          }
        };
      }

      if (show) {
        features.forEach(feat => mapObject.addLayer(feat));
      } else {
        mapObject.eachLayer(removeFeatureFunction);
      }
    },
    prepareLeafletIcon() {
      /* eslint no-underscore-dangle: 0 */
      delete L.Icon.Default.prototype._getIconUrl;

      const { iconRetinaUrl, iconUrl, shadowUrl } = this.icons;
      L.Icon.Default.imagePath = '';
      L.Icon.Default.mergeOptions({
        iconRetinaUrl,
        iconUrl,
        shadowUrl,
      });
    },
    getMarkerAttribution(data) {
      let attribution = '';

      if (data.type === 'destination' && data.percentage === 100) {
        attribution = 'finish-destination';
      } else if (data.type === 'destination' && data.percentage !== 100) {
        attribution = 'waiting-destination';
      } else if (data.type === 'origin') {
        attribution = 'origin-area';
      } else if (data.type === 'vehicle') {
        attribution = 'truck_in_movement';
      }

      return attribution;
    },
    getMarkerIcon(data) {
      let iconName = '';
      let iconPath = 'tms';
      if (data.type === 'destination' && data.percentage === 100) {
        iconName = 'destination-finish';
      } else if (data.type === 'destination' && data.percentage !== 100) {
        iconName = 'destination-waiting';
      } else if (data.type === 'origin') {
        iconName = 'origin-area';
      } else if (data.type === 'vehicle') {
        iconName = 'truck_in_movement';
        iconPath = 'bookmark';
      }
      const icon = L.icon({
        iconUrl: `https://secure-gps.street-directory.com.au/assets/img/${iconPath}/${iconName}.png`,
        iconSize: [32, 32],
        iconAnchor: [16, 32],
      });
      return icon;
    },
    getMarkerPoint(data) {
      const {
        geometry = {}, longitude, latitude, type,
      } = data;
      const geoType = get(geometry, 'type', 'Point');
      const isCircle = geoType === 'Point';
      const isVehicle = type === 'vehicle';
      let point = {
        lat: null,
        lng: null,
      };

      if (isVehicle) {
        return {
          lat: latitude,
          lng: longitude,
        };
      }

      if (isCircle) {
        point = isNull(longitude) && isNull(latitude)
          ? { lat: geometry.coordinates[0], lng: geometry.coordinates[1] }
          : { lat: latitude, lng: longitude };
      } else {
        const polygon = L.polygon(geometry.coordinates);
        point = polygon.getBounds().getCenter();
      }
      return point;
    },
    getCircleRadius(data) {
      const { metadata = {} } = data;
      const radius = !isNull(metadata.radius)
        ? metadata.radius
        : this.defaultCircleRadius;
      return radius;
    },
    getCircleCoordinates(data) {
      const { geometry, longitude, latitude } = data;
      const coordinates = isNull(longitude) && isNull(latitude)
        ? geometry.coordinates
        : [latitude, longitude];
      return coordinates;
    },
    handleExportCompletion() {
      if (this.isBusyExport) return;
      this.isBusyExport = true;
      const use_delivery_date = this.isFilterByDeliveryDate;
      const { start_date, end_date } = this.prepareRangeDate();
      const payloads = {
        startDate: start_date,
        endDate: end_date,
        useDeliveryDate: use_delivery_date,
      };
      this.$store.dispatch('shipment_md/shipments/EXPORT_PRAMBANAN_COMPLETION', payloads)
        .then((response) => {
          if (typeof response !== 'undefined') {
            if (response.file) {
              const a = document.createElement('a');
              if (typeof a.download === 'undefined') {
                window.location.href = response.file;
              } else {
                a.href = response.file;
                a.download = response.file.substring(response.file.lastIndexOf('/') + 1);
                document.body.appendChild(a);
                a.click();
              }
            }
          }
          setTimeout(() => {
            this.isBusyExport = false;
          }, 3e3);
        });
    },
  },
  watch: {
    searchQuery(value) {
      const resetData = () => {
        const defaultAllShipments = cloneDeep(this.summaries);
        this.filterSummary(defaultAllShipments);
        this.setupSortShipment();
      };

      if (!isEmpty(value)) {
        const result = this.findShipmentByValue();
        if (isEmpty(result)) {
          resetData();
        }
      } else {
        resetData();
      }
      setTimeout(() => {
        this.drawChart();
      }, 5e2);
    },
    minimizeSidebar() {
      setTimeout(() => { this.drawChart(); }, 5e2);
    },
    modeColumn() {
      clearTimeout(this.timeout);
      this.loaded = false;
      this.filteredSummaries = [];
      this.firstColumnShipment = [];
      this.secondColumnShipment = [];

      this.loadData().then(() => { this.loaded = true; });
    },
    markerPoints(points) {
      this.polyCollections = points.filter((dt) => {
        const { geometry = null } = dt;
        if (!geometry) { return false; }
        return geometry.type === 'Polygon';
      });
      this.circleCollections = points.filter((dt) => {
        const { geometry = null } = dt;
        if (!geometry) { return false; }
        return geometry.type === 'Point';
      });
    },
    showWaitingDestination() {
      this.updateStateFeatureVisibility('waiting-destination');
      this.updateStateFeatureVisibility('tooltip');
    },
    showFinishDestination() {
      this.updateStateFeatureVisibility('finish-destination');
      this.updateStateFeatureVisibility('tooltip');
    },
    showPlanRoute() {
      this.updateStateFeatureVisibility('plan-route');
    },
    showRealRoute() {
      this.updateStateFeatureVisibility('real-route');
    },
    showTooltip() {
      this.updateStateFeatureVisibility('tooltip');
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>

<style lang="sass">
  .modal-fullscreen
    max-width: 100% !important;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
    position: fixed;
    z-index: 100000;
    max-height: 100% !important;

  .content-fullscreen
    max-height: 100% !important;

  .content-fullscreen .modal-body
    text-align: center;
</style>

<style lang="sass" scoped>
  @import "~leaflet/dist/leaflet.css";

  .completion__container
    position: relative;
    width: 100% !important;
    padding: 10px;
    max-height: unset !important;
    height: unset !important;
    overflow: unset !important;

  .shipment__item
    height: 75px;
    &:hover
      opacity: 0.8;

  .leaflet-control-container
    height: 500px !important;

  .legend-container
    text-align: left;

  .completion
    font-size: 16px;
    &-setting-icon
      color: #46a8f6;
    &-download-icon
      color: #2ecc71;

  .line-mark
    display: inline-block;
    width: 35px;
    margin-bottom: 3px;

  .plan-route
    border-bottom: 3px solid red;

  .real-route
    border-bottom: 3px solid green;

  .waiting-destination,
  .finish-destination,
  .origin-area,
  .current-vehicle-location
    height: 20px;

  .legend-item
    display: inline-block;
    margin-right: 1rem;
</style>



// WEBPACK FOOTER //
// src/views/pages/completion/Index.vue